module.exports = __webpack_public_path__ + "media/SoccerScene_1.1668b930.mp4";